import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Alert from 'react-bootstrap/Alert';

import "./Speakers.css"

function Speakers() {
    const speakersData = [
        {
            "name": "prof. dr hab. n. med. Dariusz Patkowski",
            "gender": "male",
            "job_title": "SPECJALISTA CHIRURG I UROLOG DZIECIĘCY",
            "workplace": "Klinika Chirurgii i Urologii Dziecięcej, Uniwersytecki Szpital Kliniczny we Wrocławiu",
            "private": "Przewodniczący Rady Naukowej Stowarzyszenia",
            "image": "speaker_DariuszPatkowski.jpeg",
            "source": ""
        },
        {
            "name": "dr n. med. Marcin Łosin",
            "gender": "male",
            "job_title": "SPECJALISTA CHIRURG DZIECIĘCY",
            "workplace": "Klinika Chirurgii i Urologii Dzieci i Młodzieży, Gdański Uniwersytet Medyczny",
            "private": "Członek Rady Naukowej Stowarzyszenia",
            "image": "speaker_MarcinŁosin.jpg",
            "source": "Źródło: Facebook Nord Clinic"
        },
        {
            "name": "prof. dr hab. n. med. Robert Śmigiel",
            "gender": "male",
            "job_title": "SPECJALISTA GENETYK KLINICZNY, PEDIATRA",
            "workplace": "Katedra i Klinika Pediatrii, Endokrynologii, Diabetologii i Chorób Metabolicznych, Uniwersytet Medyczny we Wrocławiu",
            "private": "Członek Rady Naukowej Stowarzyszenia",
            "image": "speaker_RobertŚmigiel.jpg",
            "source": ""
        },
        {
            "name": "dr hab. Anna Rozensztrauch, prof. UMW",
            "job_title": "koordynator badań jakości życia w chorobach rzadkich",
            "gender": "female",
            "workplace": "",
            "private": "Członek Rady Naukowej Stowarzyszenia",
            "image": "speaker_AnnaRozensztrauch.jpg",
            "source": ""
        },
        {
            "name": "dr n. med. Aleksandra Jasińska",
            "job_title": "SPECJALISTA CHIRURGII DZIECIĘCEJ",
            "gender": "female",
            "workplace": "Oddział Kliniczny Chirurgii i Urologii Dziecięcej i Pediatrii, UCK WUM w Warszawie",
            "private": "",
            "image": "speaker_AleksandraJasińska.jpg",
            "source": ""
        },
        {
            "name": "dr hab. n. med. i n. o zdr. Marcin Banasiuk",
            "job_title": "Specjalista Pediatrii i Gastroenterologii Dziecięcej",
            "workplace": "Oddział Kliniczny Gastroenterologii, Żywienia Dzieci i Pediatrii, UCK WUM w Warszawie",
            "private": "",
            "image": "speaker_MarcinBanasiuk.jpg",
            "source": ""
        },
        {
            "name": "dr hab. n. med. Dorota Waśko-Czopnik, prof. PWr",
            "job_title": "Gastroenterolog, Specjalista Chorób Wewnętrznych, Konsultant Żywieniowy, Endoskopista",
            "gender": "female",
            "workplace": "Kierownik Kliniki Gastroenterologii, Hepatologii z Pododdziałem leczenia Nieswoistych Chorób Zapalnych Jelit, Katedra Nauk Klinicznych Niezabiegowych, wydział Medyczny Politechniki Wrocławskiej przy Wojewódzkim Szpitalu Specjalistycznym we Wrocławiu",
            "private": "",
            "image": "speaker_DorotaCzopnik.JPG",
            "source": ""
        },
        {
            "name": "mgr Katarzyna Warzeszak",
            "job_title": "FIZJOTERAPEUTKA ODDECHOWA",
            "gender": "female",
            "workplace": "Instytut Gruźlicy i Chorób Płuc OT w Rabce-Zdrój",
            "private": "",
            "image": "speaker_KatarzynaWarzeszak.png",
            "source": ""
        },
        {
            "name": " mgr inż. Magdalena Ciężkowska",
            "gender": "female",
            "job_title": "DIETETYCZKA DZIECIĘCA I TERAPEUTKA KARMIENIA",
            "workplace": <span>Założycielka <a href="https://www.dziecizdrowoodzywione.pl" target="_blank">www.dziecizdrowoodzywione.pl</a></span>,
            "private": "Prywatnie mama Mikołaja urodzonego z długoodcinkową atrezją przełyku.",
            "image": "speaker_MagdalenaCiężkowska.webp",
            "source": ""
        },
        {
            "name": "dr n. kf. Przemysław Kędziora",
            "gender": "male",
            "job_title": "SPECJALISTA FIZJOTERAPII",
            "workplace": "Kierownik działu rehabilitacji leczniczej Szpitala Rejonowego w Busku Zdroju",
            "private": "Prywatnie tata Emilii urodzonej z atrezją przełyku.",
            "image": "speaker_PrzemysławKędziora.jpg",
            "source": ""
        },
        {
            "name": "mgr Małgorzata Kałamejka",
            "job_title": "NAUCZYCIELKA WCZESNOSZKOLNA I PRZEDSZKOLNA, OLIGOFRENOPEDAGOG, TERAPEUTKA INTEGRACJI SENSORYCZNEJ I BOWENA",
            "gender": "female",
            "workplace": "",
            "private": "Prywatnie mama Jasia urodzonego z atrezją przełyku.",
            "image": "speaker_MałgorzataKałamejka.jpg",
            "source": ""
        }
    ]
    const maxIndex = speakersData.length;

    return (
        <>
            <Row className="g-4">
                {speakersData.slice(0, maxIndex).map((item, idx) => (
                    <Col key={idx} xs={12} sm={6} md={4} lg={4} xl={4}>
                        <Card className="speakerInfo h-100 d-flex flex-column overflow-hidden">
                            <Card.Body className="d-flex flex-column flex-grow-1 p-3">
                                <div className="mx-auto mb-3">
                                    {item.source && item.source !== "" && item.source !== null ? (
                                        <OverlayTrigger
                                            placement="bottom"
                                            overlay={<Tooltip>{item.source}</Tooltip>}
                                        >
                                            <span>
                                                <Card.Img
                                                    variant="top"
                                                    src={
                                                        item.image
                                                            ? `${process.env.PUBLIC_URL}/images/${item.image}`
                                                            : `${process.env.PUBLIC_URL}/images/anonymous_${item.gender}.jpg`
                                                    }
                                                    className="rounded-circle"
                                                    style={{
                                                        width: '140px',
                                                        height: '140px',
                                                        objectFit: 'cover',
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => window.open(item.source, '_blank')}
                                                />
                                            </span>
                                        </OverlayTrigger>
                                    ) : (
                                        <Card.Img
                                            variant="top"
                                            src={
                                                item.image
                                                    ? `${process.env.PUBLIC_URL}/images/${item.image}`
                                                    : `${process.env.PUBLIC_URL}/images/anonymous_${item.gender}.jpg`
                                            }
                                            className="rounded-circle"
                                            style={{
                                                width: '140px',
                                                height: '140px',
                                                objectFit: 'cover'
                                            }}
                                        />
                                    )}

                                </div>
                                <Card.Title className="text-center mb-2">{item.name}</Card.Title>
                                <Card.Text as="div" className="flex-grow-1 text-wrap overflow-hidden">
                                    <p className="mb-2 small">
                                        <span className="jobTitle">{item.job_title}</span>
                                        <br className="d-md-none" />
                                        <i className="d-block">{item.workplace}</i>
                                    </p>
                                    <p className="mb-0 small text-muted">
                                        {item.private}
                                    </p>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
            {/* <Row className="g-4 speakersAlert">
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Alert variant="info">
                        Wkrótce ogłosimy pozostałych prelegentów.
                    </Alert>
                </Col>
            </Row> */}
        </>
    );
}

export default Speakers;